"use client";
import styled from "styled-components";
import {Container} from "react-bootstrap";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import React, {useEffect, useRef, useState} from "react";
import Title from "@/components/common/ui/Title";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {useGSAP} from "@gsap/react";
import {Img} from "@/components/common/ui/Img";
import reactHtmlParser from "react-html-parser";
import Slider, {Slide} from "@/components/common/ui/swiper";
import {usePathname} from "next/navigation";

function Component({data}) {
    const [windowSize, setWindowSize] = useState();
    const [ScrollWidth, setScrollWidth] = useState();
    const [offset, setOffset] = useState();
    const SwiperRef = useRef();
    const pathname = usePathname();
    gsap.registerPlugin(ScrollTrigger);
    useEffect(() => {
        if (typeof window !== "undefined") {
            const windowWIdth = () => setWindowSize(window.innerWidth + 15);
            const calOffset = () =>
                setOffset(document.querySelector(".container").offsetLeft + 15);
            window.addEventListener("resize", () => {
                windowWIdth();
                calOffset();
            });
            windowWIdth();
            calOffset();
        }

        //   "width",
        //   document.querySelector(".scroll-video-items").clientWidth
        // );
    }, [data]);

    // pin & scroll animation
    useGSAP(() => {
        if (window?.innerWidth > 992) {
            gsap.set(".scroll-video-items", {
                x: document.querySelector(".container").offsetLeft + 15,
            });
            gsap
                .timeline({
                    scrollTrigger: {
                        id: `wt`,
                        trigger: ".scroll-video",
                        start: `top ${window.innerWidth > 1900 ? "-250" : "-350"}`,
                        pin: true,
                        // end: "100",
                        scrub: 1,

                        toggleActions: "play none none reverse",
                    },
                })
                .to(".scroll-video-items", {
                    ease: "linear",
                    // x: -ScrollWidth,

                    xPercent: -30,

                    // duration: 1,
                });
        }

        return () => {
            ScrollTrigger.getById("wt")?.kill(); // Proper cleanup
        };

    }, [pathname]);

    const handleSwiperInit = (swiper) => {
        return swiper;
    };


    return (
        <StyleComponent offset={offset} className="scroll-video pt-200 ">
            <p className="fixed-icon parallax-xr">
                {reactHtmlParser(data?.section_data?.subtitle)}
            </p>
            <p className="fixed-icon-2 parallax-x">
                {reactHtmlParser(data?.section_data?.short_desc)}

            </p>
            <Container>
                {/* section title */}
                <Title type={'h1'} fontWeight={500}
                    text={reactHtmlParser(data?.section_data?.extra_desc)}

                />
            </Container>

            {/* video scroll for desktop  */}
            {windowSize > 991 ? (

                <div className="scroll-video-items">

                    {
                        data?.images?.list && data?.images?.list?.length > 0 &&
                        data?.images?.list?.map((e,index) => {
                            return (
                                <div key={index} className="scroll-video-items__single">
                                    <div className="scroll-video-items__single__video">
                                        <Img alt={'Maximus Education and Migration'} src={e?.full_path}/>
                                    </div>
                                </div>
                            )
                        })
                    }


                </div>
            ) : (
                // mobile slider
                <div className="scroll-video-items">
                    <Slider
                        ref={SwiperRef}
                        loop={true}
                        spaceBetween={30}
                        slidesPerView={1}
                        allowSlideNext={true}
                        allowSlidePrev={true}
                        speed={900}
                        infinity={false}
                        modules={[Autoplay, Pagination, Navigation]}
                        autoplay={true}
                        breakpoints={{
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                        }}
                    >
                        {
                            data?.images?.list && data?.images?.list?.length > 0 &&
                            data?.images?.list?.map((e, index) => {
                                return (
                                    <Slide key={index}>

                                        <div key={index} className="scroll-video-items__single">
                                            <div className="scroll-video-items__single__video">
                                                <Img alt={'Maximus Education and Migration'} src={e?.full_path}/>
                                            </div>
                                        </div>
                                    </Slide>
                                )
                            })
                        }
                    </Slider>

                </div>
            )}
        </StyleComponent>
    );
}
const StyleComponent = styled.section`
    position: relative;
    overflow: hidden;
    padding-bottom: 200px;
    background: #F8F6F5;

    .fixed-icon {
        position: absolute;
        font-size: 200px;
        font-weight: 500;
        letter-spacing: -0.2px;
        line-height: 200px;
        color: rgba(54, 50, 49, 0.02);
        top: 100px;
        left: 0;
    }
    
    .fixed-icon-2{
        position: absolute;
        font-size: 200px;
        font-weight: 500;
        letter-spacing: -0.2px;
        line-height: 200px;
        color: rgba(54, 50, 49, 0.02);
        top: 370px;
        right: 0;
    }

    ul {
        display: flex;
        margin-top: 60px;
        justify-content: space-between;

        li {
            color: #fff;
            font-weight: 500;
            font-size: 20px;
            line-height: 24px;

            img {
                margin-right: 10px;
            }
        }
    }

    .scroll-video {
        width: 100%;
    }

    .scroll-video-items {
        width: 100%;
           transform: translateX(${(p) => p.offset}px);
        /* transform: translateX(230px); */
        @media (min-width: 991px) {
            display: flex;
            gap: 30px;
        }
        margin-top: 60px;

        &__single {
            position: relative;
            @media (min-width: 991px) {
                min-width: calc(20% - 30px);
            }

            &__video {
                padding-top: calc(480 / 270 * 100%);
                position: relative;
                border-radius: 8px;
                overflow: hidden;

                video {
                    position: absolute;
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                    inset: 0;
                }
            }
        }
    }

    @media(max-width: 1440px) and (min-width: 1024px){
        h1{
            font-size: 100px;
            line-height: 110px;
        }
    }
    
    @media (max-width: 991px) {
        ul {
            flex-wrap: wrap;

            li {
                width: 50%;
                margin-bottom: 25px;
                padding-right: 10px;

                img {
                    display: block;
                    margin-bottom: 5px;
                }
            }
        }
    }
    
    @media(max-width: 767px){
        padding-top: 180px;
        .scroll-video-items{
            padding: 0 15px;
        }
    }
`;
export default React.memo(Component)